export default __webpack_public_path__ + "static/media/Cancel.4590aa77.svg";